$(() => {
    var $organizationImportSelect = $('#OrganizationPicker select');
    var $organizationLink = $('#OrganizationPicker a');
    if ($organizationImportSelect.length > 0) {
        updateHref($organizationLink, $organizationImportSelect);
        $organizationImportSelect.change(() => {
            updateHref($organizationLink, $organizationImportSelect);
        });
    }

    if (!$('[data-employee-edit-form]').length) {
        return;
    }
    var $organizationSelect = $('#OrganizationId');
    var $departmentsSelect = $('#DepartmentId');

    if ($departmentsSelect && $departmentsSelect.length) {
        const enabled = $departmentsSelect.data('enabled');
        $departmentsSelect.prop('disabled', enabled && enabled.toUpperCase() === 'FALSE');
    }

    $organizationSelect.change(() => {
        $departmentsSelect.empty();
        $departmentsSelect.append($('<option/>', { text: $departmentsSelect.data('selectdepartmenttext'), value: '' }));

        var organizationId = $organizationSelect.val().toString();

        if (organizationId == null || !organizationId.length) {
            $departmentsSelect.prop('disabled', true);
            return;
        }

        var departmentUrl = $organizationSelect.data('departmentsurl');

        $.getJSON(`${departmentUrl}?oid=${organizationId}`,
            departments => {
                $departmentsSelect.prop('disabled', !departments.length);

                $.each(departments,
                    (index, department) => {
                        $departmentsSelect.append($('<option/>',
                            {
                                value: department.Id,
                                text: department.DepartmentName
                            }));
                    });
            });
    });

    const $isOrganizationAdmin = $('#IsOrganizationAdmin');
    const $isDepartmentAdmin = $('#IsDepartmentAdmin');

    function updateHref(link, select) {
        let href = link.attr('href');

        if (href.indexOf('?') >= 0) {
            href = href.substring(0, href.indexOf('?'));
        }
        link.attr('href', href + '?oid=' + select.val());
    }

    function initContactPersonInfoForm() {
        const $contactperson = $('.contact-person');
        let $isContactPersonField = $('#IsContactPerson');
        let $hjhContactPersonField = $('#SelectedHjhContactPerson_Id');
        let $hjhContactPersonCommentField = $('#HjhContactPersonComment');

        function updateFieldAccess() {
            let enabled = $isContactPersonField.is(':checked');

            $hjhContactPersonField.prop('disabled', !enabled);
            $hjhContactPersonCommentField.prop('disabled', !enabled);

            if (enabled) {
                $contactperson.show();
            } else {
                $contactperson.hide();
            }
        }

        $isContactPersonField.on('click', updateFieldAccess);
        updateFieldAccess();
    }

    $isOrganizationAdmin.change(() => {
        if ($isOrganizationAdmin.is(':checked')) {
            $isDepartmentAdmin.prop('checked', false);
        }
    });
    $isDepartmentAdmin.change(() => {
        if ($isDepartmentAdmin.is(':checked')) {
            $isOrganizationAdmin.prop('checked', false);
        }
    });
    initContactPersonInfoForm();
});

$('#FileButton').click(function () {
    $('#ImportFile').click();
});

$('#ImportFile').change(function () {
    $('#importButton').click();
    $('.upload-button__input').hide();
    $('.file-button-wrapper').hide();
    $('.uploading').css('display', 'flex');
});

$('#showDetails').click(function () {
    $('#detailsArea').show();
    $('#showDetails').hide();
    $('#errorArea').show();
});

$('#hideDetails').click(function () {
    $('#detailsArea').hide();
    $('#showDetails').show();
    $('#errorArea').hide();
});

$('#SendSmsBtn').on('click', function (e) {
    e.preventDefault();
    let orgId = $('#OrganizationId').val();
    let empId = $('#EmployeeId').val();
    let responseContainer = $('.sms-response');

    $.ajax({
        url: `/EmployeeAdminPage/sendsms?organizationId=${orgId}&employeeId=${empId}`,
        type: 'POST',
        async: false,
        success: function (data) {
            responseContainer.removeClass('error');
            responseContainer.addClass('success');
            responseContainer.html(data);
        },
        error: function () {
            responseContainer.removeClass('success');
            responseContainer.addClass('error');
            responseContainer.html('Sms could not be sent');
        }
    });
});
